import { useState, createContext } from "react";

export const SearchReviewsContext = createContext()

export function SearchReviewsProvider(props) {

    const initialSearch = localStorage.getItem('searchReviews')

    const [searchReviews, setSearchReviews] = useState(JSON.parse(initialSearch))

    const filterReviews = (dateFrom, dateTo, status) =>{

        const obj = {
            dateFrom: dateFrom,
            dateTo : dateTo,
            status : status
        }

        setSearchReviews(obj)
        localStorage.setItem('searchReviews',JSON.stringify(obj))
    }

    const resetReviews = () => {   
            localStorage.removeItem('searchReviews')
            setSearchReviews(null)
    }


    return(
        <SearchReviewsContext.Provider value={{ searchReviews, filterReviews, resetReviews }}>
            {props.children}
        </SearchReviewsContext.Provider>    
    )
}

